import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicSelectableModule } from 'ionic-selectable';


import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Items, User, Settings } from './services';
import { ItemDetailPageModule } from './pages/modal/item-detail/item-detail.module';
import { ItemCreatePageModule } from './pages/modal/item-create/item-create.module';

import { LocateModalPageModule } from './pages/modal/locate-modal/locate-modal.module';

import { Camera } from '@ionic-native/camera/ngx';
import { IonicStorageModule, Storage } from '@ionic/storage';
import { CacheModule } from 'ionic-cache';
import { EmailComposer } from '@ionic-native/email-composer/ngx';

import { registerLocaleData } from '@angular/common';
import { HTTP } from '@ionic-native/http/ngx';

import localeIt from '@angular/common/locales/it';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { AuthService } from './services/auth.service';
import { ShareService } from './services/share.service';
import { MyInterceptorService } from './services/my-interceptor.service';
import { SecureStorage } from '@ionic-native/secure-storage/ngx';
import { ErrorInterceptor } from './services/error-interceptor';
import { ImagePicker } from '@ionic-native/image-picker/ngx';
import { File } from '@ionic-native/file/ngx';
import { WebView } from '@ionic-native/ionic-webview/ngx';
import { FilePath } from '@ionic-native/file-path/ngx';
// import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';
import { AnalyticsService } from './analytics.service';

import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';
import { Device } from '@ionic-native/device/ngx';
import { MultiTenantService } from './services/multi-tenant.service';
import { DEFAULT_TIMEOUT, TimeoutInterceptor } from './services/TimeoutInterceptor';

import 'hammerjs';
import 'mousetrap';
import { GalleryModule } from '@ks89/angular-modal-gallery';



registerLocaleData(localeIt);

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function provideSettings(storage: Storage) {
  /**
   * The Settings provider takes a set of default settings for your app.
   *
   * You can add new settings options at any time. Once the settings are saved,
   * these values will not overwrite the saved values (this can be done manually if desired).
   */
  return new Settings(storage);
}

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),

    HttpClientModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    ItemDetailPageModule,
    ItemCreatePageModule,
    LocateModalPageModule,

    IonicStorageModule.forRoot({
      name: 'terre_turismo_db',
      driverOrder: ['indexeddb', 'websql']
      // TODO: PIER ripristinare sqlite --- Un tempo era stato rimosso, chissà perchè
      //driverOrder: ['indexeddb', 'sqlite', 'websql']

    }),

    //CacheModule.forRoot(),
    
    CacheModule.forRoot({ keyPrefix: 'terreturismo-app-cache' }),

    IonicSelectableModule,

    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production
    }),
    GalleryModule.forRoot(),
  ],
  providers: [
    EmailComposer,
    StatusBar,
    SplashScreen,
    { provide: Settings, useFactory: provideSettings, deps: [Storage] },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TimeoutInterceptor,
      multi: true
    },
    [{ provide: DEFAULT_TIMEOUT, useValue: 30000 }],

    {
      provide: HTTP_INTERCEPTORS,
      useClass: MyInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    { 
      provide: LOCALE_ID, useValue: "it-IT" 
    },
    Items,
    Camera,
    Geolocation,
    ImagePicker,
    User,
    AuthService,
    File,
    HTTP,
    ShareService,
    SecureStorage,
    WebView,
    FilePath,
    AnalyticsService,    
    MultiTenantService,
    GoogleAnalytics,
    Device

  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
